<div
  id="image-gallery"
  class="gallery"
  role="group"
  [attr.aria-label]="STRINGS.GALLERY_LABEL | translateString: language"
>
  <div class="image-outer-container">
    <div #imageContainer class="image-container">
      <button
        class="gallery-nav prev"
        aria-controls="image-container image-select-listbox"
        [attr.aria-label]="STRINGS.SHOW_PREVIOUS_IMAGE | translateString: language"
        (click)="previous()"
        type="button"
      >
        <span class="pi pi-chevron-left"></span>
      </button>
      <button
        class="gallery-nav next"
        aria-controls="image-container image-select-listbox"
        [attr.aria-label]="STRINGS.SHOW_NEXT_IMAGE | translateString: language"
        (click)="next()"
        type="button"
      >
        <span class="pi pi-chevron-right"></span>
      </button>
      <div id="image-container" class="image-inner-container" [style.left]="imagePosition">
        <figure
          *ngFor="let image of images; let i = index"
          [style.width]="width"
          [style.height]="height"
          [attr.aria-hidden]="activeIndex !== i"
          [attr.aria-live]="activeIndex === i ? 'polite' : null"
          aria-atomic="true"
          class="image-item"
          [ngClass]="{ 'has-credit': image.credit }"
        >
          <img
            class="image"
            [alt]="
              image.description ? image.description : (STRINGS.IMAGE_WITHOUT_DESCRIPTION | translateString: language)
            "
            [src]="image.url"
          />
          <figcaption class="caption">
            <div *ngIf="image.credit" class="image-credit">{{ image.credit }}</div>
          </figcaption>
        </figure>
      </div>
    </div>
  </div>
  <div
    #thumbContainer
    class="thumb-container"
    id="image-select-listbox"
    role="listbox"
    aria-orientation="horizontal"
    aria-labelledby="image-gallery"
  >
    <div class="thumb-outer-container">
      <div class="thumb-inner-container">
        <div class="thumb-item-content" *ngFor="let image of images; let i = index" [class.active]="i === activeIndex">
          <img
            class="thumb-item"
            role="option"
            [alt]="
              image.description ? image.description : (STRINGS.IMAGE_WITHOUT_DESCRIPTION | translateString: language)
            "
            [class.active]="i === activeIndex"
            [src]="image.url"
            [tabIndex]="i === activeIndex ? 0 : -1"
            [attr.aria-label]="
              image.description ? image.description : (STRINGS.IMAGE_WITHOUT_DESCRIPTION | translateString: language)
            "
            [attr.aria-selected]="i === activeIndex"
            aria-controls="image-container"
            (click)="selectImage(i)"
            (keydown.enter)="selectImage(i)"
            (keydown.arrowright)="focusNext()"
            (keydown.arrowleft)="focusPrevious()"
            (focus)="onThumbnailFocus(i)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
